<template>
  <div class="calculator">
    <div class="desktopTitleWrapper">
      <div class="desktopTitle">محاسبه کمیسیون</div>
    </div>
    <div class="calculatorTitleWrapper">
      <div class="calculatorTitle">محاسبه کمیسیون</div>
    </div>
    <div class="calculatorContainer">
      <div class="calculateColumn">
        <div class="formSwitchBtnWrapper" :class="form.cal_type">
          <div class="switchController"></div>
          <button
            class="formSwitchBtn simple"
            @click="calTypeHandler('simple')"
          >
            ساده
          </button>
          <button
            class="formSwitchBtn advance"
            @click="calTypeHandler('advance')"
          >
            پیشرفته
          </button>
        </div>
        <form class="containerForm">
          <div class="formGroup">
            <label for="contractType" class="groupLabel">نوع معامله</label>
            <div class="gropuSelectWrapper">
              <div class="inputIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z"
                  />
                  <path
                    d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z"
                  />
                </svg>
              </div>
              <el-select
                v-model="form.contract_type"
                id="contractType"
                placeholder=""
              >
                <el-option label="خرید / فروش" value="trade" />
                <el-option label="رهن / اجاره" value="rent" />
              </el-select>
            </div>
          </div>
          <div class="formGroup" v-if="form.contract_type == 'trade'">
            <label for="tradeAmount" class="groupLabel">مبلغ کل معامله</label>
            <div class="groupInputWrapper">
              <div class="inputIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                v-model="front_show.trade_amount"
                @input="onAmountInput($event, 'trade_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                id="tradeAmount"
                class="groupInput"
                inputmode="numeric"
              />
              <!-- <input
                v-model="front_show.trade_amount"
                @input="onAmountInput($event, 'trade_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                id="tradeAmount"
                class="groupInput"
                inputmode="numeric"
                @keyup="CalculateCommission"
              /> -->
              <div class="inputUnit">تومان</div>
            </div>
          </div>
          <div class="formGroup" v-if="form.contract_type == 'rent'">
            <label for="mortageAmount" class="groupLabel">مبلغ کل رهن</label>
            <div class="groupInputWrapper">
              <div class="inputIcon">
                <VsxIcon
                  iconName="Bank"
                  :size="24"
                  color="#0096c7"
                  type="bold"
                  class="mortageIcon"
                />
              </div>
              <input
                v-model="front_show.mortage_amount"
                @input="onAmountInput($event, 'mortage_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                id="mortageAmount"
                class="groupInput"
                inputmode="numeric"
              />
              <!-- <input
                v-model="front_show.mortage_amount"
                @input="onAmountInput($event, 'mortage_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                @keyup="CalculateCommission"
                id="mortageAmount"
                class="groupInput"
                inputmode="numeric"
              /> -->
              <div class="inputUnit">تومان</div>
            </div>
          </div>
          <div class="formGroup" v-if="form.contract_type == 'rent'">
            <label for="rentAmount" class="groupLabel">مبلغ کل اجاره</label>
            <div class="groupInputWrapper">
              <div class="inputIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="rentIcon"
                >
                  <path
                    d="M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z"
                    clip-rule="evenodd"
                  />
                  <path
                    d="M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z"
                  />
                </svg>
              </div>
              <input
                v-model="front_show.rent_amount"
                @input="onAmountInput($event, 'rent_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                id="rentAmount"
                class="groupInput"
                inputmode="numeric"
              />
              <!-- <input
                v-model="front_show.rent_amount"
                @input="onAmountInput($event, 'rent_amount')"
                @keydown="onlyAllowNumbers"
                type="text"
                id="rentAmount"
                class="groupInput"
                inputmode="numeric"
                @keyup="CalculateCommission"
              /> -->
              <div class="inputUnit">تومان</div>
            </div>
          </div>
          <div
            v-if="form.cal_type == 'advance' && form.contract_type == 'trade'"
            class="formGroup percentageGroup"
          >
            <label for="percentage" class="groupLabel"
              >درصد کمیسیون (اختیاری برای مشاوران)</label
            >
            <div class="gropuSelectWrapper">
              <div class="inputIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path
                    d="M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                  />
                </svg>
              </div>
              <el-select
                v-model="form.percentage"
                id="percentage"
                placeholder=""
              >
                <el-option label="0.5" value="0.5" />
                <el-option label="1" value="1" />
                <el-option label="2" value="2" />
                <el-option label="3" value="3" />
                <el-option label="4" value="4" />
                <el-option label="5" value="5" />
                <el-option label="6" value="6" />
              </el-select>
              <!-- <el-select
                v-model="form.percentage"
                @change="CalculateCommission"
                id="percentage"
                placeholder=""
              >
                <el-option label="0.5" value="0.5" />
                <el-option label="1" value="1" />
                <el-option label="2" value="2" />
                <el-option label="3" value="3" />
                <el-option label="4" value="4" />
                <el-option label="5" value="5" />
                <el-option label="6" value="6" />
              </el-select> -->
            </div>
          </div>
          <div
            v-if="form.cal_type == 'advance' && form.contract_type == 'trade'"
            class="formGroup radioGroup"
          >
            <div class="groupLabel">تعداد مشاوران املاک</div>
            <div class="groupRadiosWrapper">
              <div class="groupRadio">
                <input
                  type="radio"
                  v-model="form.consultantNum"
                  value="1"
                  class="custom-radio"
                  id="oneConsultant"
                />
                <label for="oneConsultant" class="redioLabel">
                  یک مشاور (نماینده هر دو طرف معامله)
                </label>
              </div>
              <div class="groupRadio">
                <input
                  type="radio"
                  v-model="form.consultantNum"
                  value="2"
                  class="custom-radio"
                  id="twoConsultant"
                />
                <label for="twoConsultant" class="redioLabel">
                  دو مشاور (نماینده یک طرف معامله)
                </label>
              </div>
            </div>
          </div>
          <div class="formGroupButtons">
            <div @click="CalculateCommission('withTax')" class="formButton">
              با ارزش افزوده
            </div>
            <div @click="CalculateCommission('withoutTax')" class="formButton">
              بدون ارزش افزوده
            </div>
          </div>
        </form>
      </div>
      <div class="resultColumn">
        <div class="calculatorResultWrapper">
          <div class="resultThumb">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">مبلغ قابل پرداخت</div>
              <div class="contentValue">
                <div class="valueNum">
                  {{ formatNumberWithCommas(form.TotalCommission) }}
                </div>
                <div class="valueUnit">تومان</div>
              </div>
            </div>
          </div>
          <div
            v-if="form.contract_type == 'trade' && form.cal_type == 'simple'"
            class="resultAlert"
          >
            طبق تعرفه فعلی اتحادیه، کمیسیون برای فروش
            <span>{{ formatPercentage(form.percentage) }}%</span> از هر طرف
            قرارداد می‌باشد.
          </div>
          <div
            v-if="form.contract_type == 'rent' && form.cal_type == 'simple'"
            class="resultAlert"
          >
            طبق تعرفه فعلی اتحادیه، کمیسیون برای اجاره
            <span>{{ formatPercentage(form.percentage_rent) }}%</span> از هر طرف
            قرارداد می‌باشد.
          </div>
          <div v-if="form.cal_type == 'advance'" class="resultAlert"> نرخ مالیات بر ارزش افزوده، مبلغ <span>10%</span> به ازای سهم هر طرف از کمیسیون معامله، می باشد.
          </div>
        </div>
        <div
          v-if="form.cal_type == 'advance' && form.consultantNum == '2'"
          class="calculatorResultWrapper dividedResult"
        >
          <div class="resultThumb advanceResult">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">سهم هر طرف</div>
              <div class="contentValue">
                <div class="valueNum">
                  {{ formatNumberWithCommas(form.divided_commission) }}
                </div>
                <div class="valueUnit">تومان</div>
              </div>
            </div>
          </div>
        </div>
        <div class="calculatorSetBtns">
          <div class="setBtnThumb" @click="shareContent">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">اشتراک گذاری</div>
              <div class="contentSubtitle">با دوستانتان به اشتراک بگذارید</div>
            </div>
            <div class="thumbArrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
          <div class="setBtnThumb" @click="generatePDF">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">دانلود PDF</div>
              <div class="contentSubtitle">ذخیره نتایج محاسبات</div>
            </div>
            <div class="thumbArrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Share } from "@capacitor/share";
// import { File } from "@awesome-cordova-plugins/file";
// import { FileOpener } from "@awesome-cordova-plugins/file-opener";
// import { Capacitor } from "@capacitor/core";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import iranyekanFontBase64 from "../assets/fonts/iranyekan64";
// import logoBase64 from "../assets/img/logo64";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "commssionCalculate",
  data() {
    return {
      form: {
        cal_type: "simple",
        contract_type: "trade",
        percentage: this.$store.state.c_set.percantage,
        percentage_rent: this.$store.state.c_set.percantage_rent,
        tax: 10,
        mortage_percent: 3,
        trade_amount: 0,
        mortage_amount: 0,
        rent_amount: 0,
        commission: 0,
        TotalCommission: 0,
        divided_commission: 0,
        consultantNum: "1",
      },
      front_show: {
        trade_amount: "",
        mortage_amount: "",
        rent_amount: "",
      },
    };
  },
  watch: {
    "form.cal_type": {
      handler(newVal) {
        this.resetFormFields();
        if (newVal == "simple") {
          this.form.percentage = this.$store.state.c_set.percantage;
        }
      },
    },
    "form.contract_type": {
      handler() {
        this.resetFormFields();
      },
    },
    "$store.state.c_set": {
      handler() {
        this.form.percentage = this.$store.state.c_set.percantage;
        this.form.percentage_rent = this.$store.state.c_set.percantage_rent;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    resetFormFields() {
      this.form = {
        cal_type: this.form.cal_type,
        contract_type: this.form.contract_type,
        percentage: this.$store.state.c_set.percantage,
        percentage_rent: this.$store.state.c_set.percantage_rent,
        tax: 10,
        mortage_percent: 3,
        trade_amount: 0,
        mortage_amount: 0,
        rent_amount: 0,
        commission: 0,
        TotalCommission: 0,
        divided_commission: 0,
        consultantNum: "1",
      };

      this.front_show = {
        trade_amount: "",
        mortage_amount: "",
        rent_amount: "",
      };
    },
    formatPercentage(num) {
      if (typeof num !== "number") return num;
      return num % 1 === 0 ? num.toString() : num.toFixed(1);
    },
    formatNumberWithCommas(number) {
      if (number === null || number === undefined) return "";

      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    //CalculateCommission() {
    //  let trade_amount = this.form.trade_amount;
    //  let rent_amount = this.form.rent_amount;
    //  let mortage_amount = this.form.mortage_amount;
    //  let mortage_percent = this.form.mortage_percent;
    //  let contract_type = this.form.contract_type;
    //  let percentage = this.form.percentage / 100;
    //  let percentage_rent = this.form.percentage_rent;
    //  if (contract_type == "trade") {
    //    this.form.commission = trade_amount * percentage;
    //    this.form.TotalCommission = this.form.commission;
    //    this.form.divided_commission = parseInt(this.form.TotalCommission / 2);
    //  } else if (contract_type == "rent") {
    //    this.form.commission =
    //      parseInt(mortage_amount * (mortage_percent / 100)) +
    //      parseInt(rent_amount * percentage_rent);
    //    this.form.TotalCommission = this.form.commission;
    //  }
    //},
    CalculateCommission(type) {
      let tax = this.form.tax;
      let trade_amount = this.form.trade_amount;
      let rent_amount = this.form.rent_amount;
      let mortage_amount = this.form.mortage_amount;
      let mortage_percent = this.form.mortage_percent;
      let contract_type = this.form.contract_type;
      let percentage = this.form.percentage / 100;
      let percentage_rent = this.form.percentage_rent;
      if (contract_type == "trade") {
        this.form.commission = trade_amount * percentage;
      } else if (contract_type == "rent") {
        this.form.commission =
          parseInt(mortage_amount * (mortage_percent / 100)) / 3 +
          parseInt(rent_amount * (percentage_rent / 100));
      }

      if (type == "withTax") {
        this.form.TotalCommission = parseInt(
          this.form.commission + this.form.commission * (tax / 100)
        );
        if (this.form.consultantNum == "2") {
          this.form.divided_commission = parseInt(
            this.form.TotalCommission / 3
          );
        } else {
          this.form.divided_commission = parseInt(
            this.form.TotalCommission / 2
          );
        }
      } else {
        this.form.TotalCommission = this.form.commission;
        if (this.form.consultantNum == "2") {
          this.form.divided_commission = parseInt(
            this.form.TotalCommission / 3
          );
        } else {
          this.form.divided_commission = parseInt(
            this.form.TotalCommission / 2
          );
        }
      }
    },
    //CalculateTax(type) {
    //  let commission = this.form.commission;
    //  let tax = this.form.tax;
    //  if (type == "withTax") {
    //    this.form.TotalCommission = parseInt(
    //      commission + commission * (tax / 100)
    //    );
    //    this.form.divided_commission = parseInt(this.form.TotalCommission / 2);
    //  } else {
    //    this.form.TotalCommission = parseInt(
    //      this.form.TotalCommission - commission * (tax / 100)
    //    );
    //    this.form.divided_commission = parseInt(this.form.TotalCommission / 2);
    //  }
    //},
    calTypeHandler(type) {
      this.form.cal_type = type;
    },
    onAmountInput(event, field) {
      const el = event.target;
      const raw = el.value.replace(/[^0-9]/g, "");

      const oldLength = el.value.length;
      const oldCursor = el.selectionStart;

      this.form[field] = raw;
      this.front_show[field] = this.formatWithCommas(raw);

      this.$nextTick(() => {
        const newLength = this.front_show[field].length;
        const diff = newLength - oldLength;
        el.setSelectionRange(oldCursor + diff, oldCursor + diff);
      });
    },
    onlyAllowNumbers(e) {
      const allowed = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];

      if (e.ctrlKey || e.metaKey) return;

      if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
        e.preventDefault();
      }
    },
    formatWithCommas(value) {
      if (value === null || value === undefined) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDecimal(value) {
      if (typeof value !== "number") return value;
      return value % 1 === 0 ? value.toString() : value.toFixed(1);
    },
    generatePDF() {
      // if (
      //   (this.form.contract_type == "trade" && this.form.trade_amount == 0) ||
      //   (this.form.contract_type == "rent" &&
      //     this.form.mortage_amount == 0 &&
      //     this.form.rent_amount == 0)
      // ) {
      //   toast("فیلد های مورد نظر را با مقادیر معتبر پر کنید", {
      //     type: "error",
      //     dangerouslyHTMLString: true,
      //   });
      //   return;
      // }
      // const doc = new jsPDF({
      //   orientation: "portrait",
      //   unit: "mm",
      //   format: "a5",
      // });

      // // فونت
      // doc.addFileToVFS("IRANYekan.ttf", iranyekanFontBase64);
      // doc.addFont("IRANYekan.ttf", "IRANYekan", "normal");
      // doc.setFont("IRANYekan");

      // const pageWidth = doc.internal.pageSize.getWidth();
      // // عنوان

      // doc.addImage(logoBase64, "PNG", (pageWidth - 30) / 2, 15, 30, 30);

      // doc.setFontSize(13);
      // doc.setTextColor(33, 33, 33);
      // doc.text("شمال املاک", pageWidth / 2, 54, { align: "center" });

      // doc.setFontSize(15);
      // doc.setTextColor(33, 33, 33);
      // doc.text("محاسبه کمیسیون", pageWidth / 2, 62, { align: "center" });

      // const body = [];

      // // body.push([
      // //   this.form.cal_type === "simple" ? "ساده" : "پیشرفته",
      // //   "نوع محاسبه",
      // // ]);
      // body.push([
      //   this.form.contract_type === "trade" ? "خرید / فروش" : "رهن / اجاره",
      //   "نوع معامله",
      // ]);
      // if (this.form.contract_type === "trade") {
      //   body.push([
      //     this.formatWithCommas(this.form.trade_amount),
      //     "(مبلغ معامله)تومان",
      //   ]);
      // }
      // if (this.form.contract_type === "rent") {
      //   body.push([
      //     this.formatWithCommas(this.form.mortage_amount),
      //     "(مبلغ رهن)تومان",
      //   ]);
      //   body.push([
      //     this.formatWithCommas(this.form.rent_amount),
      //     "(مبلغ اجاره)تومان",
      //   ]);
      // }
      // body.push([
      //   (this.form.contract_type === "trade"
      //     ? this.formatDecimal(this.form.percentage)
      //     : this.formatDecimal(this.form.percentage_rent)) + "٪",
      //   "درصد کمیسیون",
      // ]);

      // if (
      //   this.form.cal_type == "advance" &&
      //   this.form.contract_type == "trade"
      // ) {
      //   body.push([
      //     this.form.consultantNum == "1" ? "یک مشاور املاک" : "دو مشاور املاک",
      //     "تعداد مشاوران املاک",
      //   ]);
      // }

      // body.push([
      //   this.formatWithCommas(this.form.commission),
      //   "(مبلغ قابل پرداخت بدون ارزش افزوده)تومان",
      // ]);

      // const withTax = Math.round(
      //   this.form.commission + this.form.commission * (this.form.tax / 100)
      // );
      // body.push([
      //   this.formatWithCommas(withTax),
      //   "(مبلغ قابل پرداخت با ارزش افزوده)تومان",
      // ]);

      // if (this.form.consultantNum == "2") {
      //   body.push([
      //     this.formatWithCommas(this.form.divided_commission),
      //     "(سهم هر طرف)" + "تومان",
      //   ]);
      // }

      // // جدول
      // autoTable(doc, {
      //   startY: 70,
      //   head: [["مقدار", "عنوان"]],
      //   body,
      //   styles: {
      //     font: "IRANYekan",
      //     fontSize: 9,
      //     halign: "right",
      //     cellPadding: 3,
      //     lineColor: [200, 200, 200],
      //   },
      //   headStyles: {
      //     font: "IRANYekan",
      //     fontStyle: "normal",
      //     fontSize: 11,
      //     fillColor: [0, 150, 200],
      //     textColor: [255, 255, 255],
      //     halign: "center",
      //     cellPadding: 3,
      //   },
      //   bodyStyles: {
      //     font: "IRANYekan",
      //     fontStyle: "normal",
      //     halign: "right",
      //     fillColor: [255, 255, 255],
      //     textColor: [50, 50, 50],
      //     fontSize: 9,
      //   },
      //   alternateRowStyles: {
      //     fillColor: [245, 245, 245], // ردیف‌های زوج
      //   },
      //   columnStyles: {
      //     0: { halign: "right", fontStyle: "normal" },
      //     1: { halign: "right" },
      //   },
      // });

      // // ذخیره
      // // doc.save("commission.pdf");
      // const fileName = "commission.pdf";
      // const blob = doc.output("blob");

      // const isNative = Capacitor.isNativePlatform();

      // if (isNative) {
      //   try {
      //     window.resolveLocalFileSystemURL(
      //       File.externalRootDirectory + "Download/",
      //       function (dirEntry) {
      //         dirEntry.getFile(
      //           fileName,
      //           { create: true, exclusive: false },
      //           function (fileEntry) {
      //             fileEntry.createWriter(function (fileWriter) {
      //               fileWriter.onwriteend = async function () {
      //                 toast("فایل با موفقیت ذخیره شد", {
      //                   type: "success",
      //                 });
      //                 try {
      //                   await FileOpener.open(
      //                     File.externalRootDirectory + "Download/" + fileName,
      //                     "application/pdf"
      //                   );
      //                 } catch (openErr) {
      //                   console.error("خطا در باز کردن فایل:", openErr);
      //                   toast("باز کردن فایل با مشکل مواجه شد", {
      //                     type: "error",
      //                   });
      //                 }
      //               };
      //               fileWriter.onerror = function (err) {
      //                 console.error("خطا در نوشتن فایل:", err);
      //                 toast("خطا در نوشتن فایل", {
      //                   type: "error",
      //                 });
      //               };
      //               fileWriter.write(blob);
      //             });
      //           },
      //           function (err) {
      //             console.error("خطا در ساخت فایل:", err);
      //           }
      //         );
      //       },
      //       function (err) {
      //         console.error("خطا در دسترسی به مسیر:", err);
      //       }
      //     );
      //   } catch (err) {
      //     console.error("خطا:", err);
      //     toast("خطای کلی در ذخیره فایل ", {
      //       type: "error",
      //     });
      //   }
      // } else {
      //   const url = URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = fileName;
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //   URL.revokeObjectURL(url);
      // }

            console.log("download")
    },
    toPersianDigits(input) {
      return String(input).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    },
    formatPersianNumber(number) {
      return this.toPersianDigits(this.formatWithCommas(number));
    },
    getShareDataText() {
      const lines = [];
      const sep = ":\u200C ";

      lines.push("شمال املاک");
      lines.push("");
      lines.push("");

      lines.push(
        `محاسبه کمیسیون ${
          this.form.contract_type == "trade" ? "خرید / فروش" : "رهن / اجاره"
        }`
      );

      lines.push(
        `نوع معامله${sep}` +
          (this.form.contract_type === "trade" ? "خرید / فروش" : "رهن / اجاره")
      );

      if (this.form.contract_type === "trade") {
        lines.push(
          `مبلغ معامله${sep}` +
            this.formatPersianNumber(this.form.trade_amount) +
            " تومان"
        );
      } else {
        lines.push(
          `مبلغ رهن${sep}` +
            this.formatPersianNumber(this.form.mortage_amount) +
            " تومان"
        );
        lines.push(
          `مبلغ اجاره${sep}` +
            this.formatPersianNumber(this.form.rent_amount) +
            " تومان"
        );
      }

      const percentage =
        this.form.contract_type === "trade"
          ? this.formatDecimal(this.form.percentage)
          : this.formatDecimal(this.form.percentage_rent);

      lines.push(`درصد کمیسیون${sep}${this.toPersianDigits(percentage)}٪`);

      if (
        this.form.cal_type === "advance" &&
        this.form.contract_type === "trade"
      ) {
        lines.push(
          `تعداد مشاور${sep}` +
            (this.form.consultantNum === "1"
              ? "یک مشاور املاک"
              : "دو مشاور املاک")
        );
      }

      lines.push(
        `مبلغ بدون مالیات${sep}` +
          this.formatPersianNumber(this.form.commission) +
          " تومان"
      );

      const withTax = Math.round(
        this.form.commission + this.form.commission * (this.form.tax / 100)
      );

      lines.push(
        `مبلغ با مالیات${sep}` + this.formatPersianNumber(withTax) + " تومان"
      );

      if (this.form.consultantNum == "2") {
        lines.push(
          `سهم هر طرف${sep}` +
            this.formatPersianNumber(this.form.divided_commission) +
            " تومان"
        );
      }

      lines.push("");
      lines.push(
        "شمال املاک: اولین،  تخصصی ترین، شمالی ترین پلتفرم املاک در ایران"
      );
      lines.push("");
      lines.push("🔗 shomalamlak.ir/");

      return lines.join("\n");
    },

    async shareContent() {
      const textToShare = this.getShareDataText();
      if (
        (this.form.contract_type == "trade" && this.form.trade_amount == 0) ||
        (this.form.contract_type == "rent" &&
          this.form.mortage_amount == 0 &&
          this.form.rent_amount == 0)
      ) {
        toast("فیلد های مورد نظر را با مقادیر معتبر پر کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      if (this.$store.state.device === "Desktop") {
        if (navigator.clipboard && window.isSecureContext) {
          // استفاده از Clipboard API
          try {
            await navigator.clipboard.writeText(textToShare);
            toast("اطلاعات کمیسیون کپی شد.", {
              type: "success",
              dangerouslyHTMLString: true,
            });
          } catch (err) {
            console.error("کپی ناموفق:", err);
          }
        } else {
          // fallback با textarea
          const shareUrl = document.createElement("textarea");
          shareUrl.value = textToShare;
          document.body.appendChild(shareUrl);
          shareUrl.select();
          document.execCommand("copy");
          document.body.removeChild(shareUrl);

          toast("اطلاعات کمیسیون کپی شد.", {
            type: "success",
            dangerouslyHTMLString: true,
          });
        }
      } else {
        try {
          await Share.share({
            title: "اطلاعات کمیسیون ملک",
            text: textToShare,
            dialogTitle: "اشتراک‌گذاری با دوستان",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 32px;
  padding-top: 8px;

  .desktopTitleWrapper {
    .desktopTitle {
      margin: auto;
      width: 90%;
      font-size: 25px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 1.5em;
      padding-bottom: 15px;
      position: relative;
      font-family: "iranyekanB";
      margin-top: 100px;
      margin-bottom: 38px;
      text-align: center;

      &::after {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 5px;
        width: 100px;
        background: #000000;
        border-radius: 5px;
      }

      &::before {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 2px;
        height: 1px;
        width: 95%;
        max-width: 255px;
        background: #333;
      }
    }
  }

  .calculatorTitleWrapper {
    display: none;
    width: 100%;
    text-align: center;
    margin-top: 18px;

    .calculatorTitle {
      position: relative;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.125rem;
      margin: 16px auto 12px;
      text-align: center;

      &::after,
      &::before {
        content: "";
        display: block;
        width: 76px;
        height: 1px;
        background: rgb(213, 213, 213);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &::after {
        left: 0;
      }

      &:before {
        right: 0;
      }
    }
  }

  .calculatorContainer {
    padding-top: 16px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4%;
    align-items: flex-start;
    .formSwitchBtnWrapper {
      position: relative;
      width: 100%;
      height: 62px;
      margin-bottom: 20px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      overflow: hidden;
      padding: 4px;
      border-radius: 12px;
      background: #fff;
      border: 1px solid rgb(209, 213, 219);
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

      &.simple {
        .switchController {
          right: 4px;
        }

        .simple {
          color: #fff;
        }
      }

      &.advance {
        .switchController {
          right: 50%;
        }

        .advance {
          color: #fff;
        }
      }

      .switchController {
        width: calc(50% - 4px);
        height: calc(100% - 8px);
        background: linear-gradient(to right, #0096c7, #00b4d8);
        border-radius: 12px;
        position: absolute;
        top: 4px;
        z-index: 0;
        transition: all 0.15s;
      }

      .formSwitchBtn {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.15rem;
        z-index: 1;
        transition: all 0.15s;
      }
    }

    .containerForm {
      width: 98%;
      margin: 0 auto;

      .formGroup {
        width: 100%;
        margin-bottom: 18px;

        &.radioGroup {
          .groupLabel {
            margin-bottom: 16px;
          }
        }

        &.percentageGroup {
          .gropuSelectWrapper {
            .inputIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }
          }
        }

        .groupLabel {
          display: block;
          font-size: 0.85rem;
          margin-bottom: 8px;
          margin-right: 6px;
          opacity: 0.85;
        }

        :deep(.el-select .el-select__wrapper) {
          width: 100%;
          height: 47px;
          padding-right: 24px;
          border-radius: 5px !important;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px 52px 12px 12px !important;
          border-radius: 12px !important;
        }

        :deep(.el-select__caret) {
          color: #0096c7 !important;
        }

        .groupInput {
          width: 100%;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px !important;
          border-radius: 12px !important;
        }

        .groupInputWrapper {
          width: 100%;
          height: 47px;
          display: grid;
          grid-template-columns: 47px 1fr 47px;
          align-items: center;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 12px !important;

          .inputIcon {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 24px;
              height: 24px;

              &.mortageIcon,
              &.rentIcon {
                width: 20px;
                height: 20px;
              }
            }
          }

          .inputUnit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            font-size: 0.8rem;
          }

          .groupInput {
            width: 100%;
            height: 100%;
            border: none;
            box-shadow: none;
            border-radius: 0;
            text-align: center;
            font-size: 1rem;
          }
        }

        .gropuSelectWrapper {
          position: relative;

          .inputIcon {
            position: absolute;
            top: 50%;
            right: 14px;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            z-index: 1;

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 20px;
              height: 20px;
            }
          }
        }

        .groupRadiosWrapper {
          .groupRadio {
            display: flex;
            align-items: center;
            gap: 6px;
            &:first-of-type {
              margin-bottom: 12px;
            }

            .custom-radio {
              appearance: none;
              -webkit-appearance: none;
              width: 16px;
              height: 16px;
              border: 1px solid #0096c7;
              border-radius: 50%;
              position: relative;
              cursor: pointer;
              transition: border-color 0.2s;
              display: inline-block;
              vertical-align: middle;

              &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 10px;
                height: 10px;
                background: #0096c7;
                border-radius: 50%;
                transform: translate(-50%, -50%) scale(0);
                transition: transform 0.1s ease-in-out;
              }

              &:checked::before {
                transform: translate(-50%, -50%) scale(1);
              }
            }

            .redioLabel {
              font-size: 0.85rem;
            }
          }
        }
      }

      .formGroupButtons {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        margin-top: 36px;
        margin-bottom: 32px;

        .formButton {
          width: 100%;
          height: 54px;
          background: linear-gradient(to right, #0096c7, #00b4d8);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.95rem;
          border-radius: 12px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: all 0.1s;

          &:active {
            transform: scale(0.95);
          }
        }
      }
    }

    .calculatorResultWrapper {
      width: 100%;
      padding: 24px;
      border-radius: 1rem;
      background: linear-gradient(
        to bottom left,
        rgba(0, 150, 199, 0.1),
        transparent
      );
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

      &.dividedResult {
        margin-top: 24px;
      }

      .resultThumb {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;

        &.advanceResult {
          margin-bottom: 0 !important;
        }

        .thumbIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          width: 42px;
          height: 42px;
          background: #0096c7;
          color: #fff;

          svg {
            width: 18px;
            height: 18px;

            path {
              fill: #fff;
            }
          }
        }

        .thumbContent {
          .contentTitle {
            font-size: 0.85rem;
            margin-bottom: 4px;
            color: #6b7280;
          }

          .contentValue {
            display: flex;
            align-items: center;
            gap: 4px;
            color: #0096c7;

            .valueNum {
              font-family: "yekan", sans-serif;
              font-weight: 800;
              font-size: 1.35rem;
            }

            .valueUnit {
              font-size: 0.75rem;
            }
          }
        }
      }

      .resultAlert {
        font-size: 0.85rem;
        text-align: justify;
        padding: 12px;
        background: #fff;
        border-radius: 12px;
        line-height: 24px;
        opacity: 0.8;
        font-weight: 400;

        span {
          color: #0096c7;
        }
      }
    }

    .calculatorSetBtns {
      margin-top: 32px;
      .setBtnThumb {
        position: relative;
        padding: 1.25rem 1.5rem;
        background: linear-gradient(
          to right,
          rgba(0, 150, 199, 0.05),
          rgba(0, 180, 216, 0.05)
        );
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        gap: 16px;
        border-radius: 16px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          transform: scale(1.01);

          .thumbArrow {
            transform: translateX(-9px) translateY(-50%);
          }
        }

        &:first-of-type {
          margin-bottom: 24px;
        }

        .thumbIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          width: 42px;
          height: 42px;
          background: #0096c7;

          svg {
            width: 18px;
            height: 18px;
            path {
              fill: #fff;
            }
          }
        }

        .thumbContent {
          .contentTitle {
            color: #1f2937;
            font-size: 0.95rem;
            margin-bottom: 4px;
          }

          .contentSubtitle {
            font-size: 0.8rem;
            color: #6b7280;
          }
        }

        .thumbArrow {
          position: absolute;
          top: 50%;
          left: 16px;
          transform: translateY(-50%);
          transition: all 0.2s;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .calculator {
    padding-top: 0;

    .desktopTitleWrapper {
      display: none;
    }

    .calculatorTitleWrapper {
      display: block;
    }

    .calculatorContainer {
      display: block;

      .formSwitchBtnWrapper {
        height: 54px;

        .formSwitchBtn {
          font-size: 0.95rem;
        }
      }

      .containerForm {
        .formGroupButtons {
          margin-top: 24px;
          .formButton {
            height: 47px;
          }
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  .calculator {
    .calculatorContainer {
      .calculatorResultWrapper {
        .resultAlert {
          padding: 8px 12px !important;
        }
      }
      .calculatorSetBtns {
        margin-top: 12px !important;

        .setBtnThumb {
          &:first-of-type {
            margin-bottom: 12px !important;
          }
        }
      }
    }
  }
}

.dark {
  .calculator {
    color: #fff;

    .desktopTitleWrapper {
      .desktopTitle {
        &::after {
          background: #fff;
        }
        &::before {
          background: #ccc;
        }
      }
    }

    .calculatorContainer {
      .formSwitchBtnWrapper {
        background: #101a23;
        box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
        border: 1px solid #868e99;
      }

      .containerForm {
        .formGroup {
          :deep(.el-select .el-select__wrapper) {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;
          }
          :deep(
              .el-select
                .el-select__wrapper
                .el-select__selection
                .el-select__placeholder
                span
            ) {
            color: #fff !important;
          }
          .groupInputWrapper {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;
            color: #fff;

            .groupInput {
              background: #101a23 !important;
            }
          }
        }
      }
      .calculatorResultWrapper {
        box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);

        .resultThumb {
          .thumbContent {
            .contentTitle {
              color: #b7bdcb;
            }
          }
        }
        .resultAlert {
          background: #101a23;
        }
      }

      .calculatorSetBtns {
        .setBtnThumb {
          .thumbContent {
            .contentTitle {
              color: #9ba6b8;
            }
            .contentSubtitle {
              color: #9ea4b2;
            }
          }
        }
      }
    }
  }
}
</style>
